<div class="flex flex-col h-full w-full pb-8 overflow-hidden">
    <!-- Header -->
    <div class="flex justify-between items-center p-4 h-auto">
        <!-- Logo -->
        <div class="w-30 h-auto">
            <img class="w-90 h-auto" src="images/logo/logo.svg" />
        </div>

        <!-- Close button -->
        <button mat-icon-button mat-dialog-close (click)="closeDialog()" class="icon-size-2"
            *ngIf="shouldShowCloseButton()" data-testid="close-dialog-btn" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Instructions -->
    <div class="text-center mb-6">
        <h1 class="text-3xl font-dm font-semibold text-ferrerText">
            {{'otpvalidation.maintitle' | transloco}}
        </h1>
        <p class="text-base font-dm text-ferrerSecondary mt-1">
            {{'otpvalidation.subtitle' | transloco}}
            <span class="font-semibold text-gray-800">{{email}}</span>
        </p>
    </div>



    <!-- OTP Input Area -->
    <div class="flex-grow flex flex-col justify-center items-center mt-3 mb-6">
        <div class="grid grid-cols-6 gap-1.6 sm:gap-1.6 max-w-full flex-wrap px-2">
            <input *ngFor="let digit of code; let i = index; trackBy: trackByIndex" #codeInput type="text"
                inputmode="text" maxlength="1" autocomplete="off" class="w-full aspect-square min-w-[35px] max-w-[60px] border border-ferrerSecondary rounded-2xl text-center text-lg sm:text-xl md:text-2xl
                 focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent" [ngClass]="{
                'border-red-500 focus:ring-red-500': inputFieldsError,
                'border-[#2B3A3B] focus:ring-teal-600': !inputFieldsError
              }" [value]="code[i]" (input)="handleInput($event, i)" (keydown)="handleKeyDown($event, i)"
                (paste)="handlePaste($event)" [attr.data-testid]="'otp-input-' + i" />
        </div>
        <mat-error *ngIf="inputFieldsError" class="text-base text-red-500 mt-3 text-center">
            <mat-icon class="mr-2 text-red-500 icon-size-5">error_outline</mat-icon>
            <span>{{ errorMessage }}</span>
        </mat-error>
        <mat-error *ngIf="otpApiError" class="text-base text-red-500 mt-3 text-center">
            <mat-icon class="mr-2 text-red-500 icon-size-5">error_outline</mat-icon>
            <span>{{ otpApiError }}</span>
        </mat-error>

        @if(otpApiResendEmailError) {
        <mat-error class="text-base text-red-500 mt-3 flex items-center justify-center">
            <mat-icon class="text-red-500 mr-1"
                style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
            <span>{{ otpApiResendEmailError }}</span>&nbsp;
            <button (click)="openEmailVerifiedDialog()"
                class="text-[#006E75] hover:text-[#003E42] underline hover:underline">
                {{ 'otpvalidation.otpresendemail' | transloco }}
            </button>
        </mat-error>
        }
    </div>


    <!-- Button -->
    <!-- Button with fixed styles -->
    <button (click)="submitCode()"
        class="w-full my-button py-4 text-white rounded-full font-semibold text-base md:text-base transition h-14 shadow btnactions-base"
        [ngClass]="{
            'bg-teal-700 text-white hover:bg-teal-800': !buttonDisabled,
            'bg-gray-400 text-white opacity-50 cursor-not-allowed': buttonDisabled
        }" [disabled]="buttonDisabled" type="submit" data-testid="otp-submit-btn">
        <div class="flex items-center justify-center">
            <mat-spinner *ngIf="isLoading" [diameter]="20" class="mr-2"
                style="--mdc-circular-progress-active-indicator-color: white;"></mat-spinner>
            <span>{{ isLoading ? ('login.logging' | transloco) : ('login.loginBtn' | transloco) }}</span>
        </div>
    </button>

    <!-- Help -->
    <p class="text-base text-gray-600 mt-4 text-center">
        {{'otpvalidation.otphelptext' | transloco}} <br>
        <button (click)="resendCode()"
            class="text-[#006E75] hover:text-[#003E42] hover:underline underline-offset-2 font-medium underline"
            data-testid="resend-otp-btn">
            {{'otpvalidation.otpresend' | transloco}}
        </button>
    </p>
    <p class="text-base mt-3 text-center">
        {{ 'otpvalidation.backlogin' | transloco }} <br>
        <button (click)="backLoginDialog()" class="text-[#006E75] hover:text-[#003E42] hover:underline underline"
            data-testid="back-to-login-link">
            {{ 'login.loginBtn' | transloco }}
        </button>
    </p>
</div>